import React from 'react';
import PropTypes from 'prop-types';
import { Check, X } from 'react-feather';
import { Col, Row, UncontrolledTooltip, Alert } from 'reactstrap';
import theme from 'constants/theme';
import { parseHtml } from 'helpers/index';
import stylesCourse from 'styles/Course.module.scss';
const MTPchoiceResult = ({
  result,
  showYourAnswer,
  showCorrect,
  showCorrectIcon,
  iconsShow,
}) => {
  const listYourAnswer = result?.result;

  let answerArray = result?.data?.filter((data) => data?.correct == true);
  return (
    <div>
      {showCorrect && (
        <div className="freetext-correct-ans">
          {result?.data?.map((dt, index) => (
            <div key={index}>
              <div
                className={
                  `flexRow px-md-2 px-05 py-05 ${stylesCourse['item-section-normal']}` +
                  ` ${stylesCourse['item-section-enabled']}`
                }
                style={{
                  '--labelcolor': '#c1c9d4',
                }}
              >
                <div className="col">
                  <div className="row">
                    <span
                      className={` mtc-order-width w-100 fill-overflow-image ${stylesCourse['item-unit-title']}`}
                    >
                      <span>{parseHtml(dt.content)}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="view-page-title mt-1">Correct Answer: </div>
          {/* {answerArray?.map((dt, index) => (
            <Alert className="mt-1 ml-2">
              <div className="d-flex  align-items-center">
                <span className=" w-100 fill-overflow-image">
                  {' '}
                  {parseHtml(dt.content)}
                </span>{' '}
              </div>
            </Alert>
          ))} */}
          <Alert className="mt-1 show">
            {answerArray?.map((dt, index) => {
              return (
                <div key={index}>
                  <div
                    className={
                      `flexRow ${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow ? '#19a356' : '#c1c9d4',
                    }}
                  >
                    {iconsShow && (
                      <div
                        className="preview_test_correct_lebalgrade"
                        style={{ marginLeft: 'auto' }}
                      >
                        Correct
                      </div>
                    )}
                    <span
                      className={`w-100 px-md-2 px-05 py-05 ${stylesCourse['item-unit-label']}`}
                    >
                      <span
                        className={`w-100 mtc-order-width fill-overflow-image ${stylesCourse['item-unit-title']}`}
                      >
                        <strong>{parseHtml(dt?.content)}</strong>
                      </span>
                    </span>
                  </div>
                </div>
              );
            })}
          </Alert>
        </div>
      )}
      {showYourAnswer && (
        <div className="freetext-correct-ans-align">
          <div className="mb-1">
            <span className="view-page-title">Your Answer: </span>
          </div>
          <Alert className="show">
            {result?.resultAnswers
              ?.filter((item, index) => listYourAnswer?.[index])
              .map((item, index) => (
                <div key={index}>
                  <div
                    className={
                      `flexRow ${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow
                        ? showCorrect
                          ? item?.correct
                            ? '#19a356'
                            : '#e16969'
                          : '#c1c9d4'
                        : '#c1c9d4',
                    }}
                  >
                    {iconsShow ? (
                      showCorrect ? (
                        <>
                          {item?.correct ? (
                            <div
                              className="preview_test_correct_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Correct
                            </div>
                          ) : (
                            <div
                              className="preview_test_wrong_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Incorrect
                            </div>
                          )}
                        </>
                      ) : null
                    ) : null}
                    <span
                      className={`w-100 px-md-2 px-05 py-05 ${stylesCourse['item-unit-label']}`}
                    >
                      <span
                        className={`w-100 mtc-order-width fill-overflow-image ${stylesCourse['item-unit-title']}`}
                      >
                        <strong> {parseHtml(item.content)}</strong>
                      </span>
                    </span>
                  </div>
                </div>
              ))}
          </Alert>
        </div>
      )}
    </div>
  );
};

MTPchoiceResult.propTypes = {
  result: PropTypes.object.isRequired,
};

export default MTPchoiceResult;
